var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 33,
    viewBox: "0 0 66 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6997 21.4351V10.5881H39.0301C42.6398 10.5881 44.9724 12.22 44.9724 15.9761V16.047C44.9724 19.8031 42.6398 21.4351 39.0301 21.4351H37.6997ZM38.8482 4.00269H29.7972V28.0027H38.7684C48.1964 27.9362 52.9236 22.9206 52.9236 15.8741V15.7898C52.9236 8.69448 48.2318 4.00269 38.8482 4.00269ZM62.7771 4.02041H54.8924V28.0027H62.7771V4.02041ZM2.99902 4.02388H10.8837V28.0017H2.99902V4.02388ZM26.6486 4.0248H18.7728V12.016H10.8838V20.0115H18.7728V28.0026H26.6486V4.0248Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdi);
export default __webpack_public_path__ + "static/media/HDI.de7a7f45730b51dd6e95ad00badebe61.svg";
export { ForwardRef as ReactComponent };